

export const firstError = (errors: Record<string, string> | null) => {
  if (!errors) return null;

  const key = Object.keys(errors)[0];

  if (key === 'required') return 'Required';

  return 'Wrong data';
}
